/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1HIcon64Regular = forwardRef('ArrowDim1HIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M7.657 30.5c.07-.093.148-.183.232-.268l10.672-10.671a1.5 1.5 0 0 0-2.121-2.122L5.768 28.111a5.5 5.5 0 0 0 0 7.778L16.44 46.561a1.5 1.5 0 0 0 2.121-2.122L7.889 33.768a2.52 2.52 0 0 1-.232-.268h48.687c-.07.093-.148.183-.233.268L45.44 44.439a1.5 1.5 0 0 0 2.121 2.122l10.672-10.672a5.5 5.5 0 0 0 0-7.778L47.56 17.439a1.5 1.5 0 0 0-2.121 2.122L56.11 30.232c.085.085.163.175.233.268H7.657Z" })));
});
